import { t } from 'i18next';
import { Arrow, ArrowTopRight, IconCommunity } from '../../../Common/Icon';
import Card from './Card';
import styles from './index.module.scss';

export interface TippingInfo {
  title: string;
  description: string;
  Icon: typeof ArrowTopRight;
  isGrren?: boolean;
  url?: string;
}

const tippingInfo: TippingInfo[] = [
  {
    title: 'History of Tipping',
    description:
      'Explore the origins of tipping in the US and how it has evolved over time.',
    Icon: ArrowTopRight,
    url: '/articles/history',
  },
  {
    title: 'Psychology of Tipping',
    description:
      'Discover how social norms, personal values, and societal expectations affect our tipping behavior.',
    Icon: ArrowTopRight,
    url: '/articles/psychology',
  },
  {
    title: 'Tipping Articles',
    description:
      'Discover different perspectives on tipping practices and their influence on customers, workers, and businesses.',
    Icon: Arrow,
    isGrren: true,
    url: '/tipping-articles',
  },
];

function AllAboutTipping() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.cardsContainer}>
          {tippingInfo.map((info, i) => (
            <Card
              key={info.title}
              info={info}
              style={{ gridArea: `card-${i}` }}
            />
          ))}
          <div className={styles.customCard}>
            <h2 className={styles.title}>
              All About <span className="colorGreen">Tipping</span>
            </h2>
            <p className={styles.description}>
              Want to learn more about tipping practices and norms?
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllAboutTipping;
